export const USER_DEPARTMENT = [
  'Academic Affairs',
  'Institutional Advancement and Development',
  'Athletics Department',
  'Auxiliary Services',
  'Continuing Education',
  'Diversity and Inclusion',
  'Enrollment Management',
  'Executive Leadership',
  'Finance and Administration',
  'Information Technology Services',
  'Legal Affairs',
  'Marketing and Communications',
  'Public Safety',
  'Research',
  'Student Affairs',
  'University Libraries',
];

export type UserDepartment = typeof USER_DEPARTMENT[number];

export enum Department {
  'Academic Affairs',
  'Institutional Advancement and Development',
  'Athletics Department',
  'Auxiliary Services',
  'Continuing Education',
  'Diversity and Inclusion',
  'Enrollment Management',
  'Executive Leadership',
  'Finance and Administration',
  'Information Technology Services',
  'Legal Affairs',
  'Marketing and Communications',
  'Public Safety',
  'Research',
  'Student Affairs',
  'University Libraries',
}
